// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IHsaBalanceMonthlyRecord
 */
export interface IHsaBalanceMonthlyRecord {
    /**
     * 
     * @type {Date}
     * @memberof IHsaBalanceMonthlyRecord
     */
    date?: Date;
    /**
     * 
     * @type {number}
     * @memberof IHsaBalanceMonthlyRecord
     */
    cash_balance?: number;
    /**
     * 
     * @type {number}
     * @memberof IHsaBalanceMonthlyRecord
     */
    investment_balance?: number;
}

/**
 * Check if a given object implements the IHsaBalanceMonthlyRecord interface.
 */
export function instanceOfIHsaBalanceMonthlyRecord(value: object): value is IHsaBalanceMonthlyRecord {
    return true;
}

export function IHsaBalanceMonthlyRecordFromJSON(json: any): IHsaBalanceMonthlyRecord {
    return IHsaBalanceMonthlyRecordFromJSONTyped(json, false);
}

export function IHsaBalanceMonthlyRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): IHsaBalanceMonthlyRecord {
    if (json == null) {
        return json;
    }
    return {
        
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'cash_balance': json['cash_balance'] == null ? undefined : json['cash_balance'],
        'investment_balance': json['investment_balance'] == null ? undefined : json['investment_balance'],
    };
}

export function IHsaBalanceMonthlyRecordToJSON(json: any): IHsaBalanceMonthlyRecord {
    return IHsaBalanceMonthlyRecordToJSONTyped(json, false);
}

export function IHsaBalanceMonthlyRecordToJSONTyped(value?: IHsaBalanceMonthlyRecord | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': value['date'] == null ? undefined : ((value['date']).toISOString().substring(0,10)),
        'cash_balance': value['cash_balance'],
        'investment_balance': value['investment_balance'],
    };
}

